import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import useSWR, { useSWRConfig } from "swr";

const Userlist = () => {
  const { mutate } = useSWRConfig();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  const fetcher = async () => {
    const response = await axios.get(`${API_BASE_URL}/users`, {
      headers: {
          'X-API-Key': API_KEY
      },
    });
    console.log(response.data);
    return response.data;
  };

  const { data } = useSWR("users", fetcher);
  if (!data) return <h2>Loading...</h2>;

  const deleteUser = async (userId) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      await axios.delete(`${API_BASE_URL}/users/${userId}`);
      mutate("users");
    } else {
      return
    }  
  };

  return (
    <div className="container">
      <div className="columns">
        <div className="column is-centered">
          <h1 className="title is-size-5">Data Users</h1>
          <Link to="/users/add" className="button is-small is-primary mb-2">
            Add New
          </Link>
          <table className="table is-striped is-fullwidth is-size-7">
            <thead>
              <tr>
                <th className="th-cell-width-5">No</th>
                <th className="has-text-centered th-cell-width-10">Actions</th>                
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                
              </tr>
            </thead>
            <tbody>
              {data.map((user, index) => (
                <tr key={user.uuid}>
                  <td>{index + 1}</td>
                  <td className="has-text-centered">
                    <div className="is-inline-flex">
                      <Link
                        to={`/users/edit/${user.uuid}`}
                        className="button is-small is-info mr-1"
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() => deleteUser(user.uuid)}
                        className="button is-small is-danger"
                      >
                        Delete
                      </button>
                    </div>
                  </td>                  
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.role}</td>
                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Userlist;
